import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const TenteYenilemePage = () => {
  useEffect(() => {
    document.title = 'Tente Yenileme - İzmir Tente Tamir | Komple Yenileme Hizmeti';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir genelinde profesyonel tente yenileme hizmeti. Eski tentelerinizi baştan sona yeniliyor, modern ve dayanıklı hale getiriyoruz. 0551 372 35 12');
    }
  }, []);

  const otherServices = [
    { title: 'Tente Tamiri', link: '/hizmetler/tente-tamiri' },
    { title: 'Branda Değişimi', link: '/hizmetler/branda-degisimi' },
    { title: 'Körüklü Tente Tamiri', link: '/hizmetler/koruklu-tente-tamiri' },
    { title: 'Manuel Motorlu Tente Servisi', link: '/hizmetler/manuel-motorlu-tente-servisi' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <div className="pt-20 md:pt-24">
        <div className="w-full h-64 md:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/c88e93096f6de5c9811e165a68478633.jpg"
            alt="Tente Yenileme"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6 mt-8">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Tente Yenileme</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Tente Yenileme
              </h1>
              
              <p className="text-base text-gray-700 mb-6 leading-relaxed">
                Eski, yıpranmış ve işlevselliğini kaybetmiş tentelerinizi baştan sona yenileyerek modern, dayanıklı ve estetik bir görünüm kazandırıyoruz. İzmir Tente Tamir olarak, tente yenileme hizmetimizle mekanlarınıza yeni bir soluk getiriyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Tente Yenileme Nedir?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Tente yenileme, mevcut tente sisteminizin hem kumaş hem de mekanik aksamlarının kapsamlı bir şekilde gözden geçirilmesi, onarılması veya değiştirilmesi işlemidir. Sadece branda değişiminden farklı olarak, tente yenileme hizmeti tüm sistemi ele alır ve gerekli tüm iyileştirmeleri yapar.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Tente Yenileme Hizmetimiz Neleri Kapsar?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Kapsamlı tente yenileme hizmetimiz şu işlemleri içerir:
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Branda Yenileme</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Eski, solmuş veya yırtılmış brandanızı çıkarıp yerine yeni, dayanıklı ve UV korumalı kumaş montajlıyoruz. Geniş renk ve desen seçenekleri sunuyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Mekanizma Bakımı ve Onarımı</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Açılma-kapanma mekanizmasını tamamen kontrol ediyor, yıpranmış parçaları değiştiriyor, yağlama ve ayarlama işlemlerini yapıyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Kol ve Mafsallarda Güçlendirme</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Bükülmüş, kırılmış veya zayıflamış kolları ve mafsalları tamir ediyor veya yenileriyle değiştiriyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Motor ve Elektrik Sistemleri</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Motorlu tentelerinizin motor ve elektrik sistemlerini kontrol ediyor, arızalı parçaları değiştiriyoruz. İsterseniz manuel tentenizi motorlu sisteme dönüştürebiliriz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Çerçeve ve Montaj Noktaları</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Metal çerçeveyi kontrol ediyor, paslanma varsa temizliyor ve koruyucu boya uyguluyoruz. Duvara bağlantı noktalarını sağlamlaştırıyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Estetik İyileştirmeler</h3>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Tentenizin genel görünümünü iyileştiriyor, ek dekoratif unsurlar ekleyebiliyor ve modern bir görünüm kazandırıyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Ne Zaman Tente Yenileme Gerekir?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Aşağıdaki durumlarda tente yenileme hizmeti almanız önerilir:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Tenteniz 10 yıldan eski ve hem kumaş hem mekanizma yıpranmışsa</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Birden fazla sorun varsa (branda yırtık, kol kırık, motor arızalı vb.)</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Mekanınızın görünümünü tamamen yenilemek istiyorsanız</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Manuel tentenizi motorlu sisteme dönüştürmek istiyorsanız</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Tente güvenlik riski oluşturuyorsa</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Tente Yenileme Süreci</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Profesyonel tente yenileme sürecimiz şu adımlardan oluşur:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Detaylı İnceleme:</strong> Tentenizin tüm bileşenlerini yerinde inceliyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Yenileme Planı:</strong> Yapılması gereken işlemleri ve maliyetleri detaylı olarak sunuyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Malzeme Seçimi:</strong> Kumaş, renk ve ek özellikler konusunda size seçenekler sunuyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Yenileme İşlemi:</strong> Onayınızın ardından tüm işlemleri profesyonelce gerçekleştiriyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Test ve Teslim:</strong> Yenileme sonrası kapsamlı test yaparak size teslim ediyoruz</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Tente Yenilemenin Avantajları</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Ekonomik:</strong> Yeni tente almaya göre %40-60 daha uygun</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kapsamlı Çözüm:</strong> Tüm sorunlar bir seferde çözülür</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uzun Ömür:</strong> Yenilenen tente yıllarca sorunsuz çalışır</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Modern Görünüm:</strong> Mekanınıza yeni bir hava katar</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Garanti:</strong> Tüm işlemlerimiz garanti kapsamındadır</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Neden İzmir Tente Tamir?</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Deneyimli Ekip:</strong> 15 yılı aşkın sektör deneyimi</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kaliteli Malzeme:</strong> Dayanıklı ve UV korumalı kumaşlar</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Hızlı Servis:</strong> Kısa sürede tamamlama garantisi</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uygun Fiyat:</strong> Şeffaf ve rekabetçi fiyatlandırma</span>
                </li>
              </ul>

              <div className="bg-gray-50 rounded-xl p-6 md:p-8 mt-8">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Hemen Teklif Alın</h2>
                <p className="text-sm md:text-base text-gray-700 mb-6">
                  Tente yenileme için ücretsiz keşif ve fiyat teklifi almak isterseniz bize ulaşın
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+905513723512"
                    className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    Telefon: 0551 372 35 12
                  </a>
                  <a
                    href={`https://wa.me/905513723512?text=${encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-2.5 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    WhatsApp ile Yaz
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TenteYenilemePage;